/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule, Directive, } from '@angular/core';
import { MatCommonModule } from '../common-behaviors/common-module';
/**
 * Shared directive to count lines inside a text area, such as a list item.
 * Line elements can be extracted with a \@ContentChildren(MatLine) query, then
 * counted by checking the query list's length.
 */
export class MatLine {
}
MatLine.decorators = [
    { type: Directive, args: [{
                selector: '[mat-line], [matLine]',
                host: { 'class': 'mat-line' }
            },] },
];
/**
 * @nocollapse
 */
MatLine.ctorParameters = () => [];
function MatLine_tsickle_Closure_declarations() {
    /** @type {?} */
    MatLine.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatLine.ctorParameters;
}
/**
 * Helper that takes a query list of lines and sets the correct class on the host.
 * \@docs-private
 */
export class MatLineSetter {
    /**
     * @param {?} _lines
     * @param {?} _renderer
     * @param {?} _element
     */
    constructor(_lines, _renderer, _element) {
        this._lines = _lines;
        this._renderer = _renderer;
        this._element = _element;
        this._setLineClass(this._lines.length);
        this._lines.changes.subscribe(() => {
            this._setLineClass(this._lines.length);
        });
    }
    /**
     * @param {?} count
     * @return {?}
     */
    _setLineClass(count) {
        this._resetClasses();
        if (count === 2 || count === 3) {
            this._setClass(`mat-${count}-line`, true);
        }
        else if (count > 3) {
            this._setClass(`mat-multi-line`, true);
        }
    }
    /**
     * @return {?}
     */
    _resetClasses() {
        this._setClass('mat-2-line', false);
        this._setClass('mat-3-line', false);
        this._setClass('mat-multi-line', false);
    }
    /**
     * @param {?} className
     * @param {?} isAdd
     * @return {?}
     */
    _setClass(className, isAdd) {
        if (isAdd) {
            this._renderer.addClass(this._element.nativeElement, className);
        }
        else {
            this._renderer.removeClass(this._element.nativeElement, className);
        }
    }
}
function MatLineSetter_tsickle_Closure_declarations() {
    /** @type {?} */
    MatLineSetter.prototype._lines;
    /** @type {?} */
    MatLineSetter.prototype._renderer;
    /** @type {?} */
    MatLineSetter.prototype._element;
}
export class MatLineModule {
}
MatLineModule.decorators = [
    { type: NgModule, args: [{
                imports: [MatCommonModule],
                exports: [MatLine, MatCommonModule],
                declarations: [MatLine],
            },] },
];
/**
 * @nocollapse
 */
MatLineModule.ctorParameters = () => [];
function MatLineModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatLineModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatLineModule.ctorParameters;
}
//# sourceMappingURL=line.js.map